import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import {AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { RemoteFetchDistrict } from "../../../data/usecases/brick-management/remote-fetch-district";
import Endpoints from "../../../domain/endpoints";
import { FetchState } from "../../../domain/models/fetch-state";
import { DistrictType } from "../../../domain/models/brick-management-report/brick-management-data";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchDistrictInterface {
  districtData: DistrictType[];
  fetchDistrict: Function;
  fetchDistrictState: FetchState;
}

const initialValue = {
  districtData: [],
  fetchDistrictState: FetchState.DEFAULT,
};
const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchDistrictSlice: StateCreator<FetchDistrictInterface> = (
  set
) => ({
  ...initialValue,
  fetchDistrict: async (id: number) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    set(() => ({ fetchDistrictState: FetchState.LOADING }));

    const remoteFetchDistrict = new RemoteFetchDistrict(
      `${BASE_URL}${Endpoints.FETCH_DISTRICT_MASTER}`,
      axiosHttpClient
    );
    const payload = { hq_id: id };
    let result = await remoteFetchDistrict.fetch(payload);
    if (result) {
      set(() => ({
        districtData: result,
        fetchDistrictState: FetchState.SUCCESS,
      }));
    }
  },
});
